import React from 'react';

/**
 * The pieces of a conversation with Claude. The person's own words sit in a
 * `Bubble` on the right; what Claude says is ordinary text with a leading ✦
 * (`AiMark`), so the answer reads as part of the page rather than as chat.
 */

/** Something the person asked, in their words, right-aligned. */
export const Bubble: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div className={`st-bubble${className ? ` ${className}` : ''}`} {...rest} />
);

/**
 * A question you could ask next, sent as is when clicked: "Break down by
 * category". Quieter than a `Button` because it offers rather than acts, and
 * it leaves the list once picked.
 */
export const PromptChip = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, type = 'button', ...rest }, ref) => (
    <button ref={ref} type={type} className={`st-prompt-chip${className ? ` ${className}` : ''}`} {...rest} />
  ),
);
PromptChip.displayName = 'PromptChip';
